// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import ForYou from "./pages/ForYou";
import Auction from "./pages/Auction";
import Searchresult from "./pages/SearchResult";
import ProductDetails from "./pages/ProductDetails"; 
import AuctionDetails from "./pages/AuctionDetails";
import AddProduct from "./pages/AddProduct";
import MyAccount from "./pages/MyAccount";
import EditProfile from "./pages/EditProfile"; 
import EditProduct from "./pages/EditProduct";
import Login from "./pages/Login";
import CartPage from "./pages/Cart";
import FloatingCart from "./components/FloatingCart"; 
import UserProfile from "./pages/MyAccount";
import { CartProvider } from "./utils/cartContext"; 
import "./styles/global.css";
import LiveAuction from "./pages/LiveAuction";
import LiveStreamHost from "./pages/LiveStreamHost";
import WatchLiveStream from "./pages/WatchLiveStream";





function App() {
  return (
    <CartProvider> 
      <Router>
        <Header />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/foryou" element={<ForYou />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/search" element={<Searchresult />} />
          <Route path="/MyAccount" element={<MyAccount />} />
          <Route path="/auction" element={<Auction />} />
          <Route path="/EditProfile" element={<EditProfile />} />
          <Route path="/MyAccount/:ownerID" element={<UserProfile />} />
          <Route path="/EditProduct/:productId" element={<EditProduct />} />
          <Route path="/product/:productId" element={<ProductDetails />} />
          <Route path="/auction/:auctionId" element={<AuctionDetails />} /> 
          <Route path="/AddProduct" element={<AddProduct />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/live" element={<LiveAuction />} />
          <Route path="/livestream-host" element={<LiveStreamHost />} />
          <Route path="/livestream/:id" element={<WatchLiveStream />} />

          

        </Routes>

        <FloatingCart />
      </Router>
    </CartProvider>
  );
}

export default App;
